import React from "react"
import InfiniteScroll from "react-infinite-scroller"
import { JSONRPCErrorCatch } from "../../../error/error"
import { User } from "../../../rpcs/dist/UserRPC"
import { Loading } from "../../parts/loading"
import { SpaceWithText } from "../../parts/space-with-text"
import { UserListItem } from "../../parts/user-list-item"
import { IContainerProps } from "../../../pages/recent-episode/container"

const MAXIMUM_USER_READ_AT_ONE_TIME = 10

export interface IUserFuncProps {
  page: number
}

interface IProps {
  users: User[] | null
  update: (users: User[]) => void
  reset: () => void
  getUserFunc: (props: IUserFuncProps) => Promise<User[]>
}

interface IState {
  hasMore: boolean
}

export class AutoLoadUsers extends React.Component<IProps, IState> {
  constructor(props: IContainerProps & IProps) {
    super(props)
    this.loadMore = this.loadMore.bind(this)

    this.state = {
      hasMore: true,
    }
  }

  public componentDidMount() {
    if (this.props.users === null) {
      this.loadMore()
    }
  }

  public componentWillUnmount(): void {
    this.props.reset()
  }

  public render() {
    if (this.props.users === null) {
      return <Loading />
    }

    // エピソードがない
    if (this.props.users.length === 0) {
      return <SpaceWithText>ユーザーがみつかりません</SpaceWithText>
    }

    return (
      <InfiniteScroll
        pageStart={1}
        loadMore={this.loadMore}
        hasMore={this.state.hasMore}
        loader={<Loading key="loading" />}
      >
        {this.props.users.map(user => (
          <UserListItem key={user.id} user={user} />
        ))}
      </InfiniteScroll>
    )
  }

  private async loadMore(page: number = 1) {
    const res = await this.props
      .getUserFunc({
        page,
      })
      .catch(JSONRPCErrorCatch)

    if (res !== -1) {
      if (res.length < MAXIMUM_USER_READ_AT_ONE_TIME) {
        this.setState({
          hasMore: false,
        })
      }
      this.props.update(res)
    }
  }
}
